import { ShowCardsType } from "./CardServices";
import { boosterData } from "./BoosterServices";
import api from "./BaseServices";

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/collector`; // Modify this if your API is on a different URL

// Function to fetch all boosters with pagination (limit and offset)
export const getCollectorBoosters = async (
  limit: number,
  offset: number
): Promise<boosterData[]> => {
  const response = await api.get(`${API_URL}/boosters`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

export const getCollectorCards = async (
  limit: number,
  offset: number
): Promise<ShowCardsType[]> => {
  const response = await api.get(`${API_URL}/cards`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

export const getCollectorsArchivedBoosters = async (
  limit: number,
  offset: number
): Promise<boosterData[]> => {
  const response = await api.get(`${API_URL}/archived`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};
